import React from "react"
import { useSelector } from "react-redux"
import { Box, makeStyles, Typography } from "@material-ui/core"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import { ChooseLocation } from "shared/Modules/Location/Components/ChooseLocation"
import { selectUserIsPrivate } from "shared/Modules/User/userSelectors"
import { OnboardingDrawer } from "./OnboardingDrawer"
import { ONBOARDING_STEP_COUNT } from "../onboardingTypes"

const useStyles = makeStyles((theme) => ({
    helpText: {
        padding: theme.spacing(2),
    },
}))

type Props = Readonly<{
    onDone: () => void
    // X in the header: leave the flow without picking a location
    onClose: () => void
}>

/**
 * Step 1: pick the initial location. Same logic and endpoint as before (ChooseLocation / LocationList);
 * the user marks a location and saves it with the confirm button.
 */
export function PickLocationStep({ onDone, onClose }: Props) {
    const classes = useStyles()
    const isPrivateUser = useSelector(selectUserIsPrivate)

    return (
        <OnboardingDrawer
            name="pick-location"
            step={1}
            totalSteps={ONBOARDING_STEP_COUNT}
            onClose={onClose}
            title={
                isPrivateUser
                    ? <LocalizedStrict id="onboarding-location-title-private-user"><span>Vælg salgssted</span></LocalizedStrict>
                    : <LocalizedStrict id="onboarding-location-title"><span>Vælg lokation</span></LocalizedStrict>
            }
            description={
                <LocalizedStrict id="onboarding-location-description">
                    <span>Din lokation er stedet du normalt arbejder fra. Du kan altid skifte lokation i toppen af appen.</span>
                </LocalizedStrict>
            }
        >
            <ChooseLocation loadLocations confirm onSelect={onDone} />
            {!isPrivateUser && (
                <Box className={classes.helpText}>
                    <LocalizedStrict id="choose-location-help-text">
                        <Typography variant="subtitle2" color="textSecondary">
                            Findes din lokation ikke skal du kontakte jeres administrator.
                        </Typography>
                    </LocalizedStrict>
                </Box>
            )}
        </OnboardingDrawer>
    )
}
